import type { ResultOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';

import { useGraphQLMutation } from '../../../hooks/useGraphQLMutation.hook';

export const ThirdPartyForm_Organization_Foau_Mutation = graphql(`
  mutation ThirdPartyForm_Organization_Foau(
    $filter: IdFilterInput!
    $update: OrganizationInput!
    $versionData: VersionDataInput
  ) {
    findOneAndUpdateOrganization(
      filter: $filter
      update: $update
      versionData: $versionData
    ) {
      _id
    }
  }
`);

export type ThirdPartyForm_Organization_Foau_Result = ResultOf<
  typeof ThirdPartyForm_Organization_Foau_Mutation
>;

export const useUpdateOrganizationMutation = () =>
  useGraphQLMutation(ThirdPartyForm_Organization_Foau_Mutation);
